import { useState, useEffect } from "react";
import PromoMainMenuCategory from "@containers/Promo/PromoMainMenu/PromoMainMenuCategory";

const PromoMainMenu = ({
  categories,
  context,
  campaignSlug,
  onFiltersChange,
  activeFilters,
  currentPageCategory,
}) => {
  const [activeTree, setActiveTree] = useState({
    categorySlug: null,
    subCategorySlug: null,
    subSubCategorySlug: null,
  });

  // TODO: check logic and refactor
  useEffect(() => {
    setActiveTree({
      categorySlug: context.categoryLevel1 || categories[0].slug,
      subCategorySlug: context.categoryLevel2 || null,
      subSubCategorySlug: context.categoryLevel3 || null,
    });
  }, [context.categoryLevel1, context.categoryLevel2, context.categoryLevel3]);

  const handleSetActive = ({
    categorySlug,
    subCategorySlug,
    subSubCategorySlug,
  }) => {
    setActiveTree({
      categorySlug,
      subCategorySlug,
      subSubCategorySlug,
    });
  };

  return (
    <div className="group-with-promoDarkTheme:text-white">
      {categories.map((category) => {
        const isActiveCategory = activeTree.categorySlug === category.slug;

        return (
          <div key={category.id} className="border-b border-[#A2A2A2]">
            <PromoMainMenuCategory
              id={category.id}
              currentPageCategory={currentPageCategory}
              name={category.name}
              slug={category.slug}
              link={`/promo/${campaignSlug}/${category.slug}`}
              isActive={isActiveCategory}
              activeTree={{
                category: activeTree.categorySlug,
                subCategorySlug: activeTree.subCategorySlug,
                subSubCategorySlug: activeTree.subSubCategorySlug,
              }}
              subcategories={category.subcategories}
              onSetActive={handleSetActive}
              filters={category.filters}
              activeFilters={activeFilters}
              onFiltersChange={onFiltersChange}
            />
          </div>
        );
      })}
    </div>
  );
};

export default PromoMainMenu;
